(function($) {
	'use strict';
	$.fn.Slide__AddToCollection = function() {
		this.each(function() {

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// If this is already open, close it
				var $existing_popups = $('body > .popup'),
					slide_id = $self.data('sid');

				// If we clicked one thats already opened, close then don't continue
				if( $self.hasClass('active') ) {

					// Remove the popups
					$existing_popups.remove();
					$self.removeClass('active');

					// Stop
					return;

				}

				// Close any other existing popups
				$.Globals.closePopups();



				// Get options
				var popup = $('#slide__add-to-collection').html(),
					my_collections = $.Globals.getCollections( 'my_collection' ),
					render_obj = {
						slide_id: slide_id,
					},
					offset = $self.offset();

				// Set the offset
				render_obj.offset = {
					bottom: $.Window.height() - offset.top + 18, // <= 18 is offset from $self
					right: $.Window.width() - offset.left - $self.width(),
				};

				// Loop my collections so see if this ID is in any of them
				$.each( my_collections, function( i, collection ) {
					var found;
					if( collection.slides ) {
						found = collection.slides.find( function( slide_holder ) {
							return slide_holder.slide === slide_id;
						});
					}

					// If we found something make has_slide true
					if( found !== undefined ) {
						my_collections[i].has_slide = true;
					} else {
						my_collections[i].has_slide = false;
					}
				});
				render_obj.collections = my_collections.reverse(); // <= most recent first

				// Parse it
				Mustache.parse( popup );
				var output = Mustache.render( popup, render_obj );

				// Add it to dom and fade it in
				$.Body.append( output );

				// Activate trigger
				$self.addClass('active');

				setTimeout( function() {

					// Listen for global closes
					$.Globals.listenForGlobalClosePopup();

				}, 1 );


				// Create new collection and add this to it
				$('.add-to-new-collection').off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
					e.preventDefault();

					var $input = $('#new-collection-title'),
						$form = $('#name-new-collection');

					// Close it if it's already opened / reset it
					if( ! $form.hasClass('off') ) {
						$input.blur().val('');
						$form.addClass('off');

						return;
					}


					// Focus on it
					$input.focus();

					// Slide form out and listen for submit
					$form.removeClass('off').off( 'submit.add-to-new-collection' ).on( 'submit.add-to-new-collection', function(e) {
						e.preventDefault();

						$.Globals.ajax( 'scspaces_create_new_collection', { ctitle: $input.val(), request_from: 'popup' }, function( data ) {

							console.log(data);

							// Add slide to this collection
							$.Globals.addRemoveSlideFromCollection( data.new_collection.id, slide_id );

							// Add new collection to list
							$form.after( '<a href="#" class="explore-add-slide-to-collection has-slide off" data-collectionid="' + data.new_collection.id + '">' + data.new_collection.title + '</a>' );

							// Animate them in
							setTimeout( function(){
								$form.addClass('off');
								$input.blur().val('');
								$('.explore-add-slide-to-collection.off').removeClass('off');
							}, 10 );

						});

					});

				});


				// Just add / remove a slide from this collection
				$('.explore-add-slide-to-collection').off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
					e.preventDefault();

					var $this = $(this);

					// Add slide to this collection
					$.Globals.addRemoveSlideFromCollection( $(this).data('collectionid'), slide_id );

					$this.toggleClass('has-slide');

				});


			});


		});
		return this;
	};
}(jQuery));
